import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import coat from "../../includes/images/coat.png";
import imm from "../../includes/images/immigration.png";
import "../../includes/css/template.css";
import "../../includes/assets/5aa1fa4e/css/font-awesome.min.css";
import "../../includes/assets/40b83da1/css/bootstrap.css";
import muongozo from "../documents/muongozo.pdf";
import user_manual from "../documents/user_manual.pdf";

function Header() {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const handleModalToggle = () => {
    setShowModal(!showModal);
  };

  const [showModal2, setShowModal2] = useState(false);
  const handleModalToggle2 = () => {
    setShowModal2(!showModal2);
  };

  const home = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  };
  return (
    <>
      <div className="logoBar">
        <div className="container">
          <div className="row">
            <div className="col-md-1 col-sm-1 col-xs-1 vertical-align text-left hidden-xs">
              <img src={coat} alt="Coat of Arms Logo" />
            </div>

            <div className="col-md-10 col-sm-10 col-xs-12 vertical-align text-center">
              <div className="visible-xs">
                <img src={coat} alt="Coat of Arms Logo" />
              </div>

              {/* <h4 className="header-title">Tovuti ya Hati ya Kusafiri</h4> */}
              <h5>Tovuti ya Hati ya Kusafiri</h5>
              <nav
                className="navbar navbar-main navbar-default"
                role="navigation"
                style={{ opacity: 1 }}
              >
                <div className="container col-sm-12">
                  <div className="navbar-header">
                    <button
                      type="button"
                      className="navbar-toggle"
                      data-toggle="collapse"
                      data-target=".navbar-1"
                    >
                      <span className="sr-only">Toggle navigation</span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                  </div>

                  <div
                    className="collapse navbar-collapse navbar-1"
                    style={{ marginTop: "0px" }}
                  >
                    <ul className="nav navbar-nav">
                      <li>
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            home();
                          }}
                        >
                          Mwanzo
                        </Link>
                      </li>
                      <li>
                        <Link onClick={handleModalToggle}>Mahitaji Muhimu</Link>
                      </li>
                      <li>
                        <Link onClick={handleModalToggle2}>
                          Namna ya Kutumia Mfumo
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>

            <div className="col-md-1 col-sm-1 col-xs-1 vertical-align hidden-xs">
              <img src={imm} alt="Immigration Logo" />
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show popModal"

        >
          <div
            className="modal-content mdContent"
          >
            <div className="modal-header">
              <h5 className="modal-title">Muongozo wa Maombi ya ETD</h5>
              <button
                type="button"
                className="close"
                onClick={handleModalToggle}
              >
                &times;
              </button>
            </div>
            <div
              className="modal-body mdBody"

            >
              <iframe
                src={muongozo}
                title="Guidelines PDF"
                className="mdIframe"
              ></iframe>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleModalToggle}>
                Funga
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal2 && (
        <div
          className="modal fade show popModal"

        >
          <div
            className="modal-content mdContent"
          >
            <div className="modal-header">
              <h5 className="modal-title">Muongozo wa Maombi ya ETD</h5>
              <button
                type="button"
                className="close"
                onClick={handleModalToggle2}
              >
                &times;
              </button>
            </div>
            <div
              className="modal-body mdBody"

            >
              <iframe
                src={user_manual}
                title="Guidelines PDF"
                className="mdIframe"
              ></iframe>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={handleModalToggle2}
              >
                Funga
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
